import { render, staticRenderFns } from "./part_detail.vue?vue&type=template&id=e227cbba"
import script from "./part_detail.vue?vue&type=script&lang=js"
export * from "./part_detail.vue?vue&type=script&lang=js"
import style0 from "./part_detail.vue?vue&type=style&index=0&id=e227cbba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports